module.exports = __webpack_public_path__ + "img/bughunt.2a166205.svg";